module.exports = __webpack_public_path__ + "static/media/lock_VIP.131bf9ff.svg";